const Hamburger = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M29 6.667H3V4h26v2.667zm0 10.667H3v-2.667h26v2.667zM10 27.67h19V25H10v2.67z" fill="#000" />
    </svg>
)
export default Hamburger;